export type Testimonial = {
  quote: string
  name: string
  role: string
  location: string
}

// Replace with verified customer reviews before publishing.
export const testimonials: Testimonial[] = [
  {
    quote:
      'Instead of spending my evening building another stretching class, I open the system, choose the focus and already have a complete structure to teach.',
    name: 'Emily Carter',
    role: 'Stretching Instructor',
    location: 'Austin, USA',
  },
  {
    quote:
      'The visual sequences make the difference. I can see the positions, progressions and modifications at a glance without reading pages of theory.',
    name: 'Sophie Martin',
    role: 'Mobility Coach',
    location: 'London, UK',
  },
  {
    quote:
      'Lower body, upper body, dynamic mobility and recovery all organized in one place. My weekly planning is so much faster now.',
    name: 'Lauren Mitchell',
    role: 'Flexibility Instructor',
    location: 'Sydney, Australia',
  },
]
